import { Link } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";

const H = ({ children }) => <h2 className="text-lg font-bold text-white mt-8 mb-2">{children}</h2>;
const Sub = ({ children }) => <h3 className="text-sm font-bold text-[#39FF14] mt-4 mb-1">{children}</h3>;
const P = ({ children }) => <p className="text-sm text-[#A1B5A8] leading-relaxed mb-3">{children}</p>;
const UL = ({ items }) => (
  <ul className="list-disc list-inside text-sm text-[#A1B5A8] space-y-1 mb-3 marker:text-[#00E676]">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
const Mail = () => <a href="mailto:leclerccamille53170@gmail.com" className="text-[#39FF14] hover:underline">leclerccamille53170@gmail.com</a>;

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-[#0A100C] text-white" data-testid="legal-notice-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/login" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-[#A1B5A8] hover:text-white mb-8">
          <ArrowLeft size={16} /> Retour à la connexion
        </Link>

        <div className="flex items-center gap-3 mb-2">
          <span className="p-2.5 rounded-2xl bg-gradient-to-br from-[#00E676]/20 to-[#00E676]/5 border border-[#00E676]/20 text-[#00E676]"><Scale size={22} /></span>
          <div>
            <div className="text-[#39FF14] font-script text-xl">À Nous Turf</div>
            <h1 className="text-3xl sm:text-4xl font-black tracking-tight">Mentions légales & CGU</h1>
          </div>
        </div>
        <p className="text-xs text-[#697C6F] mb-8">Dernière mise à jour : 17 août 2026 · Version 1.0</p>

        {/* MENTIONS LÉGALES */}
        <H>1. Éditeur du site</H>
        <P>Le site À nous Turf, accessible à l'adresse https://anousturf.com, est édité par :</P>
        <div className="rounded-xl border border-[#00E676]/15 bg-[#0F1812] p-4 text-sm text-[#A1B5A8] mb-3">
          <div className="text-white font-semibold">Leclerc Camille</div>
          <div>Entrepreneur individuel</div>
          <div>SIRET : 931 273 510 00012</div>
          <div>Adresse : 5 rue des amis réunis, 49500 Segré-en-Anjou Bleu</div>
          <div className="mt-1">E-mail : <Mail /></div>
        </div>

        <H>2. Responsable de la publication</H>
        <P>Le responsable de la publication du site est Leclerc Camille, joignable à l'adresse <Mail />.</P>

        <H>3. Hébergement</H>
        <P>Le site est hébergé par :</P>
        <div className="rounded-xl border border-[#00E676]/15 bg-[#0F1812] p-4 text-sm text-[#A1B5A8] mb-3">
          <div className="text-white font-semibold">OVH SAS (OVHcloud)</div>
          <div>Société par actions simplifiée</div>
          <div>Siège social : 2 rue Kellermann, 59100 Roubaix, France</div>
          <div>RCS Lille Métropole 424 761 419</div>
          <div>Site : <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-[#39FF14] hover:underline">www.ovhcloud.com</a></div>
        </div>

        <H>4. Propriété intellectuelle</H>
        <P>L'ensemble des éléments composant le site À nous Turf (structure, textes, contenus, pronostics, logos, marques, graphismes, éléments visuels et logiciels) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de l'éditeur ou de ses partenaires.</P>
        <P>Toute reproduction, représentation, modification ou exploitation, totale ou partielle, des éléments du site sans autorisation préalable écrite est interdite et est susceptible de constituer une contrefaçon.</P>

        <H>5. Données personnelles</H>
        <P>Le traitement des données personnelles des utilisateurs est décrit dans notre <Link to="/politique-confidentialite" className="text-[#39FF14] hover:underline">politique de confidentialité</Link>, conforme au RGPD.</P>

        {/* CGU */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-[#00E676]/20 to-transparent my-8" />
        <h2 className="text-xl font-black text-white mb-2">Conditions Générales d'Utilisation (CGU)</h2>

        <H>6. Objet</H>
        <P>Les présentes conditions générales d'utilisation ont pour objet de définir les modalités et conditions dans lesquelles les utilisateurs peuvent accéder et utiliser le site et les services d'À nous Turf.</P>
        <P>En créant un compte ou en utilisant le service, l'utilisateur reconnaît avoir pris connaissance des présentes CGU et les accepter sans réserve.</P>

        <H>7. Description du service</H>
        <P>À nous Turf est un service de pronostics et de divertissement autour des courses hippiques. Il permet notamment de participer à des jeux de pronostics, de sélectionner des chevaux, de consulter des classements, des résultats et des contenus proposés par l'équipe À nous Turf.</P>
        <P>À nous Turf est un service de divertissement : il ne s'agit pas d'un opérateur de paris et aucun gain d'argent réel n'est proposé au titre du jeu.</P>

        <H>8. Accès au service</H>
        <UL items={[
          "L'accès à certaines fonctionnalités nécessite la création d'un compte.",
          "L'utilisateur s'engage à fournir des informations exactes lors de son inscription.",
          "L'utilisateur est responsable de la confidentialité de ses identifiants de connexion.",
          "Le service est en principe accessible en continu, sauf interruption pour maintenance, mise à jour ou cas de force majeure.",
        ]} />

        <H>9. Compte utilisateur et pseudo</H>
        <P>Chaque utilisateur est responsable de l'activité réalisée depuis son compte. Le pseudo choisi ne doit pas porter atteinte aux droits de tiers, ni comporter de contenu injurieux, illicite ou trompeur. Nous vous recommandons de ne pas utiliser un pseudo permettant de vous identifier directement.</P>

        <H>10. Règles de bonne conduite</H>
        <P>En utilisant le service, l'utilisateur s'engage notamment à ne pas :</P>
        <UL items={[
          "créer plusieurs comptes de manière abusive (multi-comptes) ;",
          "tenter de fausser les classements, les jeux ou les résultats ;",
          "publier des contenus illicites, injurieux, haineux ou contraires à l'ordre public ;",
          "porter atteinte au fonctionnement, à la sécurité ou à l'intégrité du site ;",
          "utiliser le service à des fins frauduleuses.",
        ]} />
        <P>Tout manquement peut entraîner la suspension ou la suppression du compte, sans préavis.</P>

        <H>11. Contenus et pronostics</H>
        <P>Les pronostics, analyses et contenus proposés sur À nous Turf sont fournis à titre informatif et de divertissement. Ils ne constituent en aucun cas un conseil, une garantie de résultat ou une incitation à parier. L'éditeur ne saurait être tenu responsable des décisions prises par les utilisateurs sur la base de ces contenus.</P>

        <H>12. Responsabilité</H>
        <P>L'éditeur met tout en œuvre pour assurer l'exactitude des informations et la disponibilité du service, sans toutefois pouvoir garantir l'absence totale d'erreurs ou d'interruptions. La responsabilité de l'éditeur ne saurait être engagée en cas de dommage résultant d'une mauvaise utilisation du service ou d'un cas de force majeure.</P>

        <H>13. Jeu responsable</H>
        <P>Les jeux d'argent et de hasard réels peuvent présenter des risques : endettement, isolement, dépendance. À nous Turf étant un service de divertissement, il rappelle l'importance d'une pratique mesurée et responsable de toute activité liée aux paris.</P>

        <H>14. Modification des CGU</H>
        <P>L'éditeur se réserve le droit de modifier à tout moment les présentes CGU afin de les adapter à l'évolution du service ou de la réglementation. La date de dernière mise à jour figure en haut de la page. En cas de modification importante, les utilisateurs pourront en être informés par les moyens appropriés.</P>

        <H>15. Droit applicable et litiges</H>
        <P>Les présentes mentions légales et CGU sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront compétents.</P>

        <H>16. Contact</H>
        <div className="rounded-xl border border-[#00E676]/15 bg-[#0F1812] p-4 text-sm text-[#A1B5A8] mb-6">
          <div className="text-white font-semibold">À nous Turf</div>
          <div>Site : https://anousturf.com</div>
          <div>E-mail : <Mail /></div>
          <div>Éditeur : Leclerc Camille</div>
        </div>
        <p className="text-xs text-[#697C6F]">Version 1.0 — 17 août 2026</p>

        <div className="mt-10">
          <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-[#39FF14] hover:underline">
            <ArrowLeft size={16} /> Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
